
import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { VueOtherDocumentScreenData } from "../infra/VueOtherDocumentScreenData"

export class OtherDocDetailComponent {
    
    document_repo:OtherDocumentRepository
    screen_data: VueOtherDocumentScreenData

    constructor(document_repo:OtherDocumentRepository, screen_data: VueOtherDocumentScreenData){
        this.document_repo = document_repo
        this.screen_data = screen_data
    }

    async get_document_url(id){
        let url = await this.document_repo.get_document_url(id)
        this.screen_data.setDocumentUrl(url)
    }

    async downloadFromUrl(o_url, filename){
        const res = await fetch(o_url)
        const blob = await res.blob();
        const url = await URL.createObjectURL(blob)
        const a = document.createElement("a");
        a.href = url;
        a.download =filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    async downloadPDF(id){
        if (!this.screen_data.document_url){
            await this.get_document_url(id)
        }
        let filename = this.screen_data.document['original_file_name']? this.screen_data.document['original_file_name'] : 'document.pdf'
        //replace extension
        filename = filename.replace(/\.[^/.]+$/, ".pdf");
        await this.downloadFromUrl(this.screen_data.document_url,filename)
    }
    async downloadCroppedPDF(id){
        let url = await this.document_repo.get_cropped_document_url(id)
        let filename = this.screen_data.document['original_file_name']? this.screen_data.document['original_file_name'] : 'document.pdf'
        //replace extension
        filename = "CROPPED_" + filename.replace(/\.[^/.]+$/, ".pdf");
        await this.downloadFromUrl(url, filename)
    }
    async downloadOriginalFile(id, original_file_name: string){
        let url = await this.document_repo.get_original_document_url(id)
        let filename = original_file_name? original_file_name : 'document.pdf'
        // no need to replace extension, we download the original file
        await this.downloadFromUrl(url, filename)
    }

    async find_by_id(id: any): Promise<any> {
        let document = await this.document_repo.find_by_id(id)
        if (document) {
            if (document.workflows.length > 0 && document.workflows[0].workflow_template) {
                let allStages = document.workflows[0].workflow_template.stages
                let currentStage = document.workflows[0].current_stage
                this.screen_data.setAllStages(allStages)
                this.screen_data.setCurrentStage(currentStage)
            }
            this.screen_data.setDocument(document)
        }
        
    }

    async aproveDocument(id: any): Promise<any> {
        this.screen_data.setLoadingAprove(true)
        await this.document_repo.aproveDocument(id)
        await this.find_by_id(id)
        this.screen_data.setLoadingAprove(false)
    }

    async rejectDocument(id: any): Promise<any> {
        this.screen_data.setLoadingRejected(true)
        await this.document_repo.rejectDocument(id)
        await this.find_by_id(id)
        this.screen_data.setDocument(id)
        this.screen_data.setLoadingRejected(false)
    }

    async saveDocumentComments(id, comments): Promise<any> {
        this.screen_data.setLoadingSave(true)
        let args = { doc_id: id, comments: comments }
        await this.document_repo.saveDocumentComments(args)
        await this.find_by_id(id)
        this.screen_data.setLoadingSave(false)
        this.screen_data.setDirty(false)
    }

    async continueWorkflow(id:number) {
        this.screen_data.setLoadingContinue(true)
        await this.document_repo.callContinueWorkflow({ doc_id: id })
        await this.find_by_id(id)
        this.screen_data.setLoadingContinue(false)
    }
}